// Material Dashboard 2 React Base Styles
import borders from "theme/base/borders";
import typography from "theme/base/typography";

// Material Dashboard 2 React Helper Functions
import pxToRem from "theme/base/pxToRem";
import colors from "theme/theme-light/colors";
const { text, background } = colors;
const { size, fw_semibold_500 } = typography;
const { borderRadius } = borders;

const root = {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: size.md_16,
  fontWeight: fw_semibold_500,
  borderRadius: borderRadius.md_4,
  minHeight: pxToRem(40),
  padding: `${pxToRem(8)} ${pxToRem(16)}`,
  textTransform: "none",
  fontFamily: "Averta Std CY,sans-serif",
  lineHeight: "24px",
  "& .material-icons": {
    fontSize: pxToRem(15),
    marginTop: pxToRem(-2),
  },
  backgroundColor: background.bgBrand,
  color: text.textWhite,
  "&:hover": {
    backgroundColor: background.bgBrand,
  },
  "&:active, &:active:focus, &:active:hover": {
    opacity: 0.85,
  },
  "& .material-icon, .material-icons-round, svg": {
    fontSize: `${pxToRem(16)} !important`,
  },
  "&.Mui-disabled": {
    backgroundColor: background.bgSecondary,
    color: text.textDisable,
    "&:hover": {
      backgroundColor: background.bgSecondary,
    },
  },
};

export default root;
